export default {
    id: "4bd09aac-ecf6-46a2-a97d-122b7e217258",
    icon: "mdi-comment",
    name: "shapeCallout",
    title: "Shape Callout",
    description: "A block callout",
}